import { Theme, alpha, checkboxClasses } from '@mui/material'
import { DataGridPremiumComponents } from '@mui/x-data-grid-premium/themeAugmentation'

import typography from '~/theme/typography'

import { OwnerStateThemeType } from './'

const DataGrid = (): DataGridPremiumComponents<Theme> => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          border: 0,
          color: theme.palette.text.primary,
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none'
          }
        }),
        toolbarContainer: ({ theme }: OwnerStateThemeType) => ({
          paddingRight: `${theme.spacing(5)} !important`,
          paddingLeft: `${theme.spacing(3.25)} !important`
        }),
        columnHeaders: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.customColors.tableHeaderBg
        }),
        columnHeader: ({ theme }: OwnerStateThemeType) => ({
          '&:not(.MuiDataGrid-columnHeaderCheckbox)': {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(5)
            }
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(5)
          }
        }),
        columnHeaderCheckbox: ({ theme }: OwnerStateThemeType) => ({
          maxWidth: '58px !important',
          minWidth: '58px !important',
          [`& .${checkboxClasses.root}.${checkboxClasses.checked}`]: {
            color: theme.palette.accent.main
          }
        }),
        columnHeaderTitleContainer: {
          padding: 0
        },
        columnHeaderTitle: {
          ...typography.body2,
          fontWeight: 700
        },
        columnSeparator: ({ theme }: OwnerStateThemeType) => ({
          color: theme.palette.divider
        }),
        row: ({ theme }: OwnerStateThemeType) => ({
          '&:last-child': {
            '& .MuiDataGrid-cell': {
              borderBottom: 0
            }
          },
          '&.Mui-selected': {
            backgroundColor: alpha(theme.palette.accent.main, 0.08),
            '&:hover': {
              backgroundColor: alpha(theme.palette.accent.main, 0.12)
            }
          }
        }),
        cell: ({ theme }: OwnerStateThemeType) => ({
          borderColor: theme.palette.divider,
          '&:not(.MuiDataGrid-cellCheckbox)': {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(5)
            }
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(5)
          },
          '&:focus, &:focus-within': {
            outline: 'none'
          }
        }),
        cellCheckbox: ({ theme }: OwnerStateThemeType) => ({
          maxWidth: '58px !important',
          minWidth: '58px !important',
          [`& .${checkboxClasses.root}.${checkboxClasses.checked}`]: {
            color: theme.palette.accent.main
          }
        }),
        editInputCell: ({ theme }: OwnerStateThemeType) => ({
          padding: 0,
          color: theme.palette.text.primary,
          '& .MuiInputBase-input': {
            padding: 0
          }
        }),
        footerContainer: ({ theme }: OwnerStateThemeType) => ({
          borderTop: `1px solid ${theme.palette.divider}`,
          '& .MuiTablePagination-toolbar': {
            paddingLeft: `${theme.spacing(4)} !important`,
            paddingRight: `${theme.spacing(4)} !important`
          },
          '& .MuiTablePagination-select': {
            color: theme.palette.text.primary
          }
        }),
        selectedRowCount: ({ theme }: OwnerStateThemeType) => ({
          margin: 0,
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4)
        })
      }
    }
  }
}

export default DataGrid
